export default {"src":"/_next/static/media/face_mismatch.7c51fe6c.svg","height":220,"width":351,"blurWidth":0,"blurHeight":0};